import { createDataModuleActions } from '@perpay-web/data-module/createDataModuleActions';

const fetchDataModuleActions = createDataModuleActions('FETCH_PAYMENTS');

export const fetchActivePayments = fetchDataModuleActions.dataRequest;
export const fetchActivePaymentsSuccess = fetchDataModuleActions.dataSuccess;
export const fetchActivePaymentsError = fetchDataModuleActions.dataError;
export const resetFetchActivePayments = fetchDataModuleActions.dataReset;
